import React from 'react';
import OSCAR from '../components/OSCAR';
import './OSCARPage.css';

const OSCARPage = () => {
  return (
    <div className="oscar-page">
      <div className="oscar-page-header">
        <h1>OSCAR</h1>
        <p>
          <span className="acronym-letter">O</span>pen{' '}
          <span className="acronym-letter">S</span>earch{' '}
          <span className="acronym-letter">C</span>onversational{' '}
          <span className="acronym-letter">A</span>i{' '}
          <span className="acronym-letter">R</span>esponder
        </p>
        <p/><p/><p/>
        <p>AI assistant for OpenSearch SSA Office Hours meetings</p>
      </div>
      <div className="oscar-page-content">
        <OSCAR />
      </div>
    </div>
  );
};

export default OSCARPage;
